import { render, staticRenderFns } from "./IT2104List.vue?vue&type=template&id=2e0a7b0a&scoped=true&"
import script from "./IT2104List.vue?vue&type=script&lang=ts&"
export * from "./IT2104List.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a7b0a",
  null
  
)

export default component.exports